<script setup lang="ts">
import { ISetTip } from '~/lib/models/events'

const appStore = useAppStore()
const { trackAddTip } = useGTM()
const { t } = useLocale()

const tipSelectedIndex = ref(-1)

const options = computed(() => appStore.ecommerceConfig?.tipsOptions.options || [])
const appliedCustomAmount = computed(() => {
  if (appStore.cartTipOption?.custom && appStore.cartTipOption.amount)
    return appStore.cartTipOption.amount
  return undefined
})

const setTip = async (payload: ISetTip) => {
  const option =
    payload.option && payload.amount
      ? {
          ...payload.option,
          amount: typeof payload.amount === 'string' ? parseInt(payload.amount) : payload.amount,
        }
      : payload.option
  await appStore.setCartTips(option)
  tipSelectedIndex.value = !option ? -1 : payload.index
  if (option) trackAddTip(appStore.cartTip)
}

onMounted(() => {
  // Check previous selected tip
  if (appStore.cartTipOption) {
    const { amount, type, custom } = appStore.cartTipOption
    tipSelectedIndex.value = options.value.findIndex(
      tOption => (custom && tOption.custom) || (amount === tOption.amount && type === tOption.type)
    )
  }
})
</script>

<template>
  <section class="mb-8 md:mb-10">
    <header class="w-full text-base font-bold md:text-lg">
      {{ t('checkout.sections.tip.title') }}
    </header>
    <p class="mb-5 mt-3 text-xs">{{ t('checkout.sections.tip.description') }}</p>
    <div data-test="tips__container" class="flex flex-row gap-4 md:gap-8">
      <template v-for="(opt, idx) of options" :key="idx">
        <Tip
          v-if="!opt.custom"
          :option="opt"
          :index="idx"
          :is-selected="idx === tipSelectedIndex"
          @set-tip="setTip"
        />
        <TipCustom
          v-else
          :option="opt"
          :index="idx"
          :is-selected="idx === tipSelectedIndex"
          :custom-amount="appliedCustomAmount"
          @set-tip="setTip"
        />
      </template>
    </div>
  </section>
</template>
